import TianMuScene from '@/page/control-ts/scene/TianMuScene/index.vue';
import XiDingScene from '@/page/control-ts/scene/XiDingScene/index.vue';
import LightStripScene from '@/page/control-ts/scene/LightStripScene/index.vue';

/**
 * 自定义图片场景（TransportType === 1）路由/组件解析，与 CopySceneDialog / sceneList 保持一致
 */
export function isTransportImageScene(item) {
  return Number(item?.TransportType) === 1;
}

/** 回收站弹窗内嵌查看用的场景组件 */
export function getImageSceneViewComp(item) {
  if (item.ShowEntry === 4) return TianMuScene;
  if (item.ShowEntry === 5) return XiDingScene;
  return LightStripScene;
}

export function getImageSceneRoute(item, from = 'copy') {
  const params = {
    SceneNo: item.SceneNo,
    GpNo: item.GpNo,
    from
  };

  if (item.ShowEntry === 4) {
    return { name: 'tianmu', params };
  }
  if (item.ShowEntry === 5) {
    return { name: 'xidingdengScene', params };
  }
  return { name: 'lightStripScene', params };
}

/** window.open 新标签页 params 不入 URL，需用 query */
export function getImageSceneWindowRoute(item, gpNo, from = 'edit') {
  const query = {
    SceneNo: item.SceneNo,
    GpNo: gpNo,
    from
  };

  if (item.ShowEntry === 4) {
    return { name: 'tianmu', query };
  }
  if (item.ShowEntry === 5) {
    return { name: 'xidingdengScene', query };
  }
  return { name: 'lightStripScene', query };
}

/** 读取路由参数：query 兼容 window.open，params 优先兼容同页 push */
export function mergeSceneRouteOpts(route) {
  return { ...route.query, ...route.params };
}
